import PropTypes from "prop-types";
import { Box, Divider, Stack, Typography } from "@mui/material";

import { ChartOfAccountSelect } from "@/features/chart-of-accounts";
import { AccountingActionAllowedTypes } from "../accounting-action-allowed-types";
import { AccountingActionLabel } from "../accounting-action-labels";
import {
  REQUIRED_ACTIONS,
  SINGLE_SELECT_ACTIONS,
} from "../action-section-mapping";

export const PreferenceTab = ({
  sections,
  preferences,
  onUpdatePreferences,
  readOnly,
  invalidActions,
}) => {
  return (
    <Stack spacing={4}>
      {sections.map((section, index) => (
        <Box key={section.title}>
          {index > 0 && <Divider sx={{ mb: 3 }} />}

          <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
            {section.icon && (
              <Box sx={{ color: "primary.main", display: "flex" }}>
                {section.icon}
              </Box>
            )}
            <Typography variant="h6" color="primary">
              {section.title}
            </Typography>
          </Box>

          <Stack spacing={3}>
            {section.actions.map((action) => {
              const isMultiple = !SINGLE_SELECT_ACTIONS.has(action);
              const isRequired = REQUIRED_ACTIONS.has(action);
              const hasError = Boolean(invalidActions?.has(action));

              return (
                <Box key={action}>
                  <Typography variant="subtitle1" gutterBottom>
                    {AccountingActionLabel[action]}
                    {isRequired && (
                      <Typography component="span" color="error">
                        {" *"}
                      </Typography>
                    )}
                  </Typography>

                  <ChartOfAccountSelect
                    multiple={isMultiple}
                    readOnly={readOnly}
                    types={AccountingActionAllowedTypes[action]}
                    value={
                      isMultiple
                        ? preferences[action] || []
                        : preferences[action]?.[0] || null
                    }
                    onChange={(value) =>
                      onUpdatePreferences(
                        action,
                        isMultiple ? value : value ? [value] : [],
                      )
                    }
                    TextFieldProps={{
                      placeholder: "Cari dan pilih akun...",
                      error: hasError,
                      helperText: hasError ? "Harus diisi" : undefined,
                    }}
                  />
                </Box>
              );
            })}
          </Stack>
        </Box>
      ))}
    </Stack>
  );
};

PreferenceTab.propTypes = {
  sections: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      icon: PropTypes.node,
      actions: PropTypes.arrayOf(PropTypes.string).isRequired,
    }),
  ).isRequired,
  preferences: PropTypes.objectOf(
    PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string.isRequired,
        code: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
      }),
    ),
  ).isRequired,
  onUpdatePreferences: PropTypes.func.isRequired,
  readOnly: PropTypes.bool,
  invalidActions: PropTypes.instanceOf(Set),
};
